import React from "react";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { SignerStamp } from "./DynamicSignerStampList";
import { api } from "@/lib/trpc/client";
import { AutocompleteSignersInput } from "./AutocompleteSignersInput";
import { AutocompleteStampsInput } from "./AutocompleteStampsInput";
interface SignerStampRowProps {
  row: SignerStamp;
  institutionId: string;
  referenceOptions?: {
    value: string;
    label: string;
    type: "reference";
  }[];
  onUpdate: (id: string, field: "user" | "role", value: {
    id: string;
    name: string;
  } | null) => void;
  onRemove?: () => void;
}
export default function SignerStampRow({
  row,
  onUpdate,
  onRemove,
  referenceOptions,
  institutionId
}: SignerStampRowProps) {
  return <div className="flex items-center space-x-4" data-sentry-component="SignerStampRow" data-sentry-source-file="SignerStampRow.tsx">
      <AutocompleteSignersInput initialValue={row.user?.id} onValueAction={value => onUpdate(row.id, "user", value)} referenceOptions={referenceOptions} institutionId={institutionId} placeholder="Select user" data-sentry-element="AutocompleteSignersInput" data-sentry-source-file="SignerStampRow.tsx" />
      <AutocompleteStampsInput initialValue={row.role?.id} onValueAction={value => onUpdate(row.id, "role", value)} institutionId={institutionId} signerId={row.user?.id} placeholder="Setare Viză" disabled={!row.user?.id} data-sentry-element="AutocompleteStampsInput" data-sentry-source-file="SignerStampRow.tsx" />
      {onRemove && <Button variant="ghost" size="icon" onClick={onRemove}>
          <Trash2 className="h-4 w-4" />
        </Button>}
    </div>;
}